import * as React from 'react';

function VerkadaCameraIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M16.7499 12H20.3819C20.5523 12.0001 20.7198 12.0437 20.8686 12.1267C21.0174 12.2098 21.1425 12.3294 21.2321 12.4744C21.3217 12.6194 21.3727 12.7848 21.3804 12.955C21.388 13.1252 21.3521 13.2946 21.2759 13.447L19.2419 17.516C19.1648 17.6702 19.0491 17.8018 18.9061 17.8981C18.7631 17.9944 18.5976 18.0521 18.4258 18.0656C18.2539 18.0791 18.0815 18.0479 17.9252 17.9751C17.7689 17.9022 17.6341 17.7903 17.5339 17.65L15.4099 14.68M2 19H5.76C6.13273 19.0026 6.49877 18.901 6.81682 18.7066C7.13487 18.5122 7.39228 18.2329 7.56 17.9L9 15M2 21V17M7 9H7.01M17.1061 9.05292C17.3431 9.17156 17.5233 9.37945 17.6071 9.6309C17.6909 9.88235 17.6715 10.1568 17.5531 10.3939L14.4471 16.6049C14.3883 16.7224 14.307 16.8272 14.2078 16.9132C14.1085 16.9993 13.9933 17.0649 13.8687 17.1064C13.7441 17.1479 13.6125 17.1645 13.4815 17.1551C13.3504 17.1458 13.2225 17.1107 13.1051 17.0519L3.61008 12.2999C2.92042 11.9525 2.39644 11.3461 2.1528 10.6133C1.90917 9.88055 1.96572 9.0811 2.31008 8.38992L3.69008 5.59992C3.86208 5.25714 4.09992 4.9516 4.39002 4.70075C4.68012 4.4499 5.01679 4.25866 5.3808 4.13794C5.74482 4.01722 6.12905 3.96939 6.51155 3.99718C6.89406 4.02497 7.26734 4.12784 7.61008 4.29992L17.1061 9.05292Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='16.0391' y='0.994141' width='7.08392' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M18.4508 2.41232L19.5583 5.89343H19.6008L20.7104 2.41232H21.7843L20.2048 6.99414H18.9564L17.3747 2.41232H18.4508Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default VerkadaCameraIcon;
